import { Link } from "react-router-dom";

/**
 * Marque Roof Border : le logo officiel, cliquable.
 *
 * Un seul dessin pour les deux thèmes (décision de Jeff), en deux mises en
 * page : « horizontal » (satellite + ROOFBORDER sur une ligne) pour les
 * en-têtes larges, « etroit » (BORDER sous ROOF) pour la barre latérale et le
 * bandeau mobile, où l'horizontal déborderait.
 */
const FICHIERS = {
  horizontal: "logo-roofborder-horizontal.png",
  etroit: "logo-roofborder-etroit.png",
};

const HAUTEURS = {
  sm: "h-6",
  md: "h-8",
  lg: "h-10",
  xl: "h-[70px]",
};

export default function Marque({ taille = "md", variante = "horizontal", className = "", vers = "/" }) {
  const h = HAUTEURS[taille] || HAUTEURS.md;
  // L'horizontal fait ~230 px de large en h-8 : à côté du sélecteur de langue
  // et du bouton de connexion, l'en-tête public dépassait l'écran d'un
  // téléphone et toute la page défilait de gauche à droite. Sous 640 px, la
  // variante horizontale sert donc le dessin étroit — même logo, même hauteur,
  // le tiers de la largeur. Les appels qui demandent « etroit » explicitement
  // (barre latérale, bandeau mobile de l'app) ne changent pas.
  const image = variante === "horizontal" ? (
    <>
      <img src={`${process.env.PUBLIC_URL}/${FICHIERS.etroit}`} alt="Roof Border"
        className={`${h} w-auto shrink-0 sm:hidden ${className}`} />
      <img src={`${process.env.PUBLIC_URL}/${FICHIERS.horizontal}`} alt="Roof Border"
        className={`${h} w-auto shrink-0 hidden sm:block ${className}`} />
    </>
  ) : (
    <img
      src={`${process.env.PUBLIC_URL}/${FICHIERS[variante] || FICHIERS.horizontal}`}
      alt="Roof Border"
      className={`${h} w-auto shrink-0 ${className}`}
    />
  );
  // vers = "" pour un usage déjà enveloppé dans un lien (pas de <a> imbriqué).
  if (!vers) return image;
  return (
    <Link to={vers} aria-label="Roof Border" className="inline-flex items-center shrink-0">
      {image}
    </Link>
  );
}
